import React, { useState } from 'react';
import { Polyline } from 'react-leaflet';

/**
 * Composant Polyline avec effet de surbrillance au survol
 */
function HighlightablePolyline({
                                   positions,
                                   color,
                                   weight = 5,
                                   opacity = 0.8,
                                   dashArray = null,
                                   isAlternative = false,
                                   showBorder = false,
                                   forceHover = false  // NOUVEAU
                               }) {
    const [isHovered, setIsHovered] = useState(false);

    const handleMouseOver = () => {
        setIsHovered(true);
    };

    const handleMouseOut = () => {
        setIsHovered(false);
    };

    // Combiner le hover local et le forceHover
    const shouldHighlight = isHovered || forceHover;

    // Styles de base
    const baseWeight = weight;
    const baseOpacity = opacity;

    // Styles au survol
    const hoveredWeight = weight + 3;
    const hoveredOpacity = 1;

    return (
        <>
            {/* Bordure blanche si demandée (pour route standard) */}
            {showBorder && (
                <Polyline
                    positions={positions}
                    pathOptions={{
                        color: 'white',
                        weight: shouldHighlight ? hoveredWeight + 2 : baseWeight + 2,
                        opacity: shouldHighlight ? 1 : baseOpacity,
                        dashArray: dashArray,
                    }}
                    eventHandlers={{
                        mouseover: handleMouseOver,
                        mouseout: handleMouseOut,
                    }}
                />
            )}

            {/* Trait principal */}
            <Polyline
                positions={positions}
                pathOptions={{
                    color: color,
                    weight: shouldHighlight ? hoveredWeight : baseWeight,
                    opacity: shouldHighlight ? hoveredOpacity : baseOpacity,
                    dashArray: dashArray,
                }}
                eventHandlers={{
                    mouseover: handleMouseOver,
                    mouseout: handleMouseOut,
                }}
            />

            {/* Effet de glow au survol */}
            {shouldHighlight && (
                <Polyline
                    positions={positions}
                    pathOptions={{
                        color: color,
                        weight: hoveredWeight + 6,
                        opacity: 0.3,
                        dashArray: dashArray,
                    }}
                />
            )}
        </>
    );
}

export default HighlightablePolyline;